import { ReactNode } from "react";

const Header = ({ children }: { children: ReactNode }) => {
  return (
    <div
      className="w-full bg-primary-blue bg-blend-overlay md:p-6 mt-24"
      style={{
        backgroundImage: "url('/header-background.png')",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <div className="md:px-10">{children}</div>
    </div>
  );
};

export default Header;
